(function () {
  "use strict";

  // OpenAI Ads Measurement Pixel events for the AEVART Shopify storefront.
  var config = window.aevartOpenAIAds || {};
  var consentGranted = false;
  var initialEventsSent = false;
  var cartListenerAttached = false;
  var attributionConfirmedKey = "";
  var attributionDesiredKey = "";
  var attributionWriteQueue = Promise.resolve();
  var cartQuantitySnapshot = Object.create(null);

  function canMeasure() {
    return consentGranted && typeof window.oaiq === "function";
  }

  function measure(name, data, options) {
    if (!canMeasure()) return;
    if (options) {
      window.oaiq("measure", name, data, options);
      return;
    }
    window.oaiq("measure", name, data);
  }

  function rawQueryValue(name) {
    var query = window.location.search.slice(1);
    if (!query) return "";

    var parts = query.split("&");
    for (var i = 0; i < parts.length; i += 1) {
      var separator = parts[i].indexOf("=");
      var key = separator === -1 ? parts[i] : parts[i].slice(0, separator);
      if (key === name) {
        return separator === -1 ? "" : parts[i].slice(separator + 1);
      }
    }
    return "";
  }

  function rawCookieValue(name) {
    var prefix = name + "=";
    var cookies = document.cookie ? document.cookie.split(";") : [];
    for (var i = 0; i < cookies.length; i += 1) {
      var cookie = cookies[i].replace(/^\s+/, "");
      if (cookie.indexOf(prefix) === 0) return cookie.slice(prefix.length);
    }
    return "";
  }

  function safeOpaqueReference(value) {
    return typeof value === "string" && value.length > 0 && value.length <= 2048 ? value : "";
  }

  function cartUpdateUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || "/";
    return root.charAt(root.length - 1) === "/" ? root + "cart/update.js" : root + "/cart/update.js";
  }

  function isRetryableCartStatus(status) {
    return status === 408 || status === 425 || status === 429 || status >= 500;
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function postCartAttributes(attributes, writeKey, attempt) {
    if (writeKey !== attributionDesiredKey) return Promise.resolve(false);

    var controller = typeof window.AbortController === "function" ? new window.AbortController() : null;
    var timeout = controller
      ? window.setTimeout(function () {
          controller.abort();
        }, 3500)
      : null;
    var requestOptions = {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ attributes: attributes }),
      keepalive: true
    };
    if (controller) requestOptions.signal = controller.signal;

    return fetch(cartUpdateUrl(), requestOptions)
      .then(function (response) {
        if (timeout) window.clearTimeout(timeout);
        if (response.ok) return true;
        var error = new Error("cart_attribute_write_failed");
        error.retryable = isRetryableCartStatus(response.status);
        throw error;
      })
      .catch(function (error) {
        if (timeout) window.clearTimeout(timeout);
        if (writeKey !== attributionDesiredKey) return false;
        var retryable = !error || error.name === "AbortError" || error.retryable !== false;
        if (!retryable || attempt >= 2) throw error;
        return wait(attempt === 0 ? 200 : 600).then(function () {
          return postCartAttributes(attributes, writeKey, attempt + 1);
        });
      });
  }

  function queueCartAttribution(consentMarker, oppref, obref) {
    var attributes = {
      __openai_ads_consent: consentMarker,
      __openai_ads_oppref: oppref,
      __openai_ads_obref: obref
    };
    var writeKey = JSON.stringify([consentMarker, oppref, obref]);
    if (writeKey === attributionDesiredKey || writeKey === attributionConfirmedKey) {
      return attributionWriteQueue;
    }
    attributionDesiredKey = writeKey;

    attributionWriteQueue = attributionWriteQueue
      .catch(function () {
        return false;
      })
      .then(function () {
        if (writeKey !== attributionDesiredKey) return false;
        return postCartAttributes(attributes, writeKey, 0);
      })
      .then(function (written) {
        if (written && writeKey === attributionDesiredKey) attributionConfirmedKey = writeKey;
        return written;
      })
      .catch(function () {
        if (writeKey === attributionDesiredKey) attributionDesiredKey = "";
        return false;
      });

    return attributionWriteQueue;
  }

  function clearAttributionFromCart() {
    return queueCartAttribution("", "", "");
  }

  function syncAttributionToCart() {
    if (!consentGranted) return clearAttributionFromCart();

    var oppref = safeOpaqueReference(rawQueryValue("oppref") || rawCookieValue("__oppref"));
    var obref = safeOpaqueReference(rawCookieValue("__obref"));
    return queueCartAttribution("granted_v1", oppref, obref);
  }

  function pageContent() {
    return {
      id: window.location.pathname || "/",
      name: config.pageTitle || document.title,
      content_type: "page"
    };
  }

  function sendInitialEvents() {
    if (!canMeasure() || initialEventsSent) return;
    initialEventsSent = true;

    measure("page_viewed", {
      type: "contents",
      contents: [pageContent()]
    });

    if (config.pageType === "product" && config.product) {
      var product = {
        id: String(config.product.id),
        name: config.product.name,
        content_type: "product",
        quantity: 1,
        amount: Number(config.product.amount),
        currency: config.currency
      };
      measure("contents_viewed", {
        type: "contents",
        amount: Number(config.product.amount),
        currency: config.currency,
        contents: [product]
      });
    }
  }

  function itemKey(item) {
    if (!item) return "";
    var value = item.key || item.variant_id || item.id || item.product_id;
    return value == null ? "" : String(value);
  }

  function replaceCartQuantitySnapshot(items) {
    var nextSnapshot = Object.create(null);
    (Array.isArray(items) ? items : []).forEach(function (item) {
      var key = itemKey(item);
      if (key) nextSnapshot[key] = Math.max(0, Math.trunc(Number(item.quantity) || 0));
    });
    cartQuantitySnapshot = nextSnapshot;
  }

  function contentFromCartItem(item, quantity) {
    var content = {
      id: String(item.sku || item.variant_id || item.id || item.product_id || "product"),
      name: item.product_title || item.title || "Product",
      content_type: "product",
      quantity: quantity,
      amount: Number(item.final_price != null ? item.final_price : item.price) || 0,
      currency: config.currency
    };
    return content;
  }

  function requestedAddedItems(event) {
    var firstParameter = event && Array.isArray(event.params) ? event.params[0] : null;
    var requested = Array.isArray(firstParameter) ? firstParameter : firstParameter ? [firstParameter] : [];
    var responseItems = Array.isArray(event && event.items) ? event.items : [];
    var used = Object.create(null);

    return requested
      .map(function (request, requestIndex) {
        var requestedId = request && request.id != null ? String(request.id) : "";
        var responseIndex = -1;
        for (var index = 0; index < responseItems.length; index += 1) {
          if (used[index]) continue;
          var responseId = responseItems[index].variant_id != null
            ? String(responseItems[index].variant_id)
            : String(responseItems[index].id || "");
          if (requestedId && requestedId === responseId) {
            responseIndex = index;
            break;
          }
        }
        if (responseIndex === -1 && responseItems[requestIndex] && !used[requestIndex]) {
          responseIndex = requestIndex;
        }
        if (responseIndex === -1) return null;

        var quantity = Math.trunc(Number(request.quantity));
        if (!Number.isFinite(quantity) || quantity <= 0) return null;
        used[responseIndex] = true;
        return contentFromCartItem(responseItems[responseIndex], quantity);
      })
      .filter(Boolean);
  }

  function sendItemsAdded(contents) {
    if (!canMeasure() || !contents.length) return;
    var amount = contents.reduce(function (total, item) {
      return total + item.amount * item.quantity;
    }, 0);

    measure("items_added", {
      type: "contents",
      amount: Math.round(amount),
      currency: config.currency,
      contents: contents
    });
    syncAttributionToCart();
  }

  function onCartUpdated(event) {
    if (!event || !window.themeCore || !window.themeCore.CartApi) return;
    var actions = window.themeCore.CartApi.actions || {};
    var eventItems = Array.isArray(event.items) ? event.items : [];

    if (event.action === actions.ADD_TO_CART || event.action === actions.ADD_TO_CART_MANY) {
      sendItemsAdded(requestedAddedItems(event));
      return;
    }

    if (event.action === actions.CHANGE_CART_ITEM_QUANTITY) {
      var changedKey = event.params && event.params[0] != null ? String(event.params[0]) : "";
      var previousQuantity = cartQuantitySnapshot[changedKey];
      var changedItem = eventItems.find(function (item) {
        return itemKey(item) === changedKey;
      });
      var currentQuantity = changedItem ? Math.max(0, Math.trunc(Number(changedItem.quantity) || 0)) : 0;
      if (previousQuantity != null && currentQuantity > previousQuantity) {
        sendItemsAdded([contentFromCartItem(changedItem, currentQuantity - previousQuantity)]);
      }
    }

    if (Number.isInteger(Number(event.item_count))) {
      replaceCartQuantitySnapshot(eventItems);
    }
  }

  function attachCartListener() {
    if (cartListenerAttached) return true;
    var eventBus = window.themeCore && window.themeCore.EventBus;
    if (!eventBus || typeof eventBus.listen !== "function") return false;
    var cart = window.themeCore && window.themeCore.cartObject;
    replaceCartQuantitySnapshot(cart && cart.items);
    eventBus.listen("cart:updated", onCartUpdated);
    cartListenerAttached = true;
    return true;
  }

  function grantConsent() {
    if (!consentGranted) {
      consentGranted = true;
      window.oaiq("consent", true);
      sendInitialEvents();
    }
    syncAttributionToCart();
  }

  function revokeConsent() {
    consentGranted = false;
    if (typeof window.oaiq === "function") window.oaiq("consent", false);
    clearAttributionFromCart();
  }

  function synchronizeConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var allowed = false;
    try {
      allowed = Boolean(
        privacy &&
          typeof privacy.analyticsProcessingAllowed === "function" &&
          typeof privacy.marketingAllowed === "function" &&
          typeof privacy.saleOfDataAllowed === "function" &&
          privacy.analyticsProcessingAllowed() === true &&
          privacy.marketingAllowed() === true &&
          privacy.saleOfDataAllowed() === true
      );
    } catch (_error) {
      allowed = false;
    }

    if (allowed) grantConsent();
    else revokeConsent();
  }

  function initializePrivacy() {
    document.addEventListener("visitorConsentCollected", synchronizeConsent);

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== "function") {
      revokeConsent();
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function (error) {
        if (error) {
          revokeConsent();
          return;
        }
        synchronizeConsent();
      }
    );
  }

  initializePrivacy();

  var attempts = 0;
  var cartListenerTimer = window.setInterval(function () {
    attempts += 1;
    if (attachCartListener() || attempts >= 100) window.clearInterval(cartListenerTimer);
  }, 100);
})();
